import { useQuery } from '@tanstack/react-query'
import { usersAPI } from 'api/usersAPI'
import { useSelector } from 'react-redux'

export default function useClientUsers(clientId: number) {
  const currentUser = useSelector((state: any) => state.users.user)
  const roles = Array.isArray(currentUser?.roles) ? currentUser.roles : []

  const query = useQuery(
    ['clientUsers', clientId],
    () => usersAPI.getUsersByClientId(Number(clientId)),
    {
      enabled: clientId > 0 && typeof clientId === 'number',
    },
  )

  const response = query?.data
  const users =
    roles.length === 1 && roles.includes('Traveller')
      ? []
      : response?.data?.value

  return {
    users,
    ...query,
  }
}
